import React, { Dispatch } from 'react';
import AlertModalDialog from '../AlertModalDialog';
import { useTranslation } from 'react-i18next';
import { showViewFileErrorDialog } from '../../../../redux/project/file/sliceProjectFileOpen';
import { useDispatch } from 'react-redux';

export default () => {
    const { t } = useTranslation('translations', { keyPrefix: 'viewFileErrorDialog' });
    const dispatch: Dispatch<unknown> = useDispatch();

    const callbackClose = () => {
        dispatch(showViewFileErrorDialog(false));
    };

    return (
        <AlertModalDialog
            isOpen={true}
            dialogTitle={t('title')}
            dialogBody={t('body')}
            confirmText={'OK'}
            onConfirm={callbackClose}
            onClose={callbackClose}
            isActionDisabled={false}
        />
    );
};
